import React, { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import ToggleButton from '@mui/material/ToggleButton';
import { Skeleton, Stack, Typography, useMediaQuery } from '@mui/material';
import styles from './styles';
import StyledToggleButtonGroup from '../../eir-mobile-offer-toggle/MobileOfferToggle.styled';
import { getCookie, setCookie } from '../../../hooks/useCookie';
import { getPrepayAddons } from './handsetDetails.util';

const PrepayStandalonePortingToggle = ({
  storages,
  selected,
  loadingHandset,
  handleClick,
  setIsPrepayHandset,
  handsetCode,
  addons,
  setAddons,
}) => {
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.down('sm'));
  const [portingType, setPortingType] = useState('');
  const [toggleTitle, setToggleTitle] = useState('');
  const [stockIndex, setStockIndex] = useState();
  const [isReady, setIsReady] = useState(false);
  const [portingOptedIn, setPortingOptedIn] = useState(false);
  /**
   * @function getAddons
   * @description - Function to load prepay addons
   */
  const getAddons = async () => {
    const data = await getPrepayAddons({ handsetCode });
    setAddons(data);
  };

  useEffect(() => {
    setStockIndex(storages.findIndex(res => res.value === selected.storage));
  });
  useEffect(() => {
    console.log('Inside useEffect');
  }, addons);

  const handleKeepMyNumber = () => {
    setCookie('PREPAY', 'STANDALONE_PORTIN', 'true');
    setIsPrepayHandset(true);
    setToggleTitle('I want to keep my number');
    setPortingOptedIn(true);
    handleClick();
    console.log('handset porting ', portingOptedIn);
    getAddons();
  };
  const handleGetNewNumber = () => {
    setCookie('PREPAY', 'STANDALONE_PORTIN', 'false');
    setIsPrepayHandset(true);
    setToggleTitle('I want to get new number');
    setPortingOptedIn(false);
    handleClick();
    getAddons();
  };
  const handleChange = (event, portType) => {
    setPortingType(portType);
  };

  /* Check if it has porting value */
  useEffect(() => {
    const standalone = getCookie('PREPAY_STANDALONE_PORTIN');
    if (standalone) {
      setIsPrepayHandset(true);
      setPortingType(getCookie('STANDALONE_PORTIN') === 'true' ? 'keepNumber' : 'getNumber');
    }
    setIsReady(true);
  }, []);
  if (!isReady) return null;

  return !loadingHandset ? (
    <Stack sx={{ pb: sm ? '0px' : '20px' }}>
      <Typography variant='subtitle2' sx={styles(theme).colorTitle}>
        Switch to eir:
        <Typography variant='body2' sx={styles(theme).storageValue}>
          &nbsp; {toggleTitle}
        </Typography>
      </Typography>
      <Stack direction='row' sx={{ mb: sm ? '80px' : '0px' }}>
        <StyledToggleButtonGroup
          size='small'
          onChange={handleChange}
          exclusive
          value={portingType}
          sx={styles(theme).toggleSelector}
          standaloneHandset
        >
          <ToggleButton
            sx={styles(theme).storageButton}
            height={40}
            value='keepNumber'
            onClick={handleKeepMyNumber}
            disabled={stockIndex !== undefined && storages[stockIndex]?.disable}
          >
            <Typography variant='body1' sx={styles(theme).portingValue}>
              Keep my number
            </Typography>
          </ToggleButton>

          <ToggleButton
            sx={styles(theme).storageButton}
            height={40}
            value='getNumber'
            onClick={handleGetNewNumber}
            disabled={stockIndex !== undefined && storages[stockIndex]?.disable}
          >
            <Typography variant='body1' sx={styles(theme).portingValue}>
              Get a new number
            </Typography>
          </ToggleButton>
        </StyledToggleButtonGroup>
      </Stack>
    </Stack>
  ) : (
    <Stack>
      <Skeleton variant='text' width='30%' />
      <Stack direction='row'>
        {Array(2)
          .fill()
          .map((_, i) => (
            <Skeleton key={i} sx={{ flex: 0.2, mr: 2 }} height={40} />
          ))}
      </Stack>
    </Stack>
  );
};

export default PrepayStandalonePortingToggle;
